import React from 'react';
import PropTypes from 'prop-types';

import Select from 'react-select';

import {
    FormLabel,
    FormDescription,
    FormError,
} from '/components/forms/components';

const SelectField = ({ input, label, options, description, meta, required }) => (
    <div className={meta.touched && meta.error ? "form-item form-item--error" : "form-item"}>
        <FormLabel label={label} required={required} />
        <Select
            {...input}
            className="react-select"
            classNamePrefix="react-select"
            options={options}
            placeholder
        />
        <FormDescription description={description} />
        {meta.touched && <FormError error={meta.error} />}
    </div>
);

SelectField.propTypes = {
    input: PropTypes.shape({}).isRequired,
    label: PropTypes.string.isRequired,
    description: PropTypes.string,
    meta: PropTypes.shape({
        touched: PropTypes.bool,
        error: PropTypes.string,
    }).isRequired,
    required: PropTypes.bool,
};

SelectField.defaultProps = {
    description: '',
    required: false,
};

export { SelectField };
